/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseFeedbackDto
 */
export interface CaseFeedbackDto {
    /**
     * 
     * @type {string}
     * @memberof CaseFeedbackDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFeedbackDto
     */
    feedbackType?: CaseFeedbackDtoFeedbackTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseFeedbackDto
     */
    rating?: CaseFeedbackDtoRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseFeedbackDto
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFeedbackDto
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof CaseFeedbackDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CaseFeedbackDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CaseFeedbackDto
     */
    tenantId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CaseFeedbackDto
     */
    metadata?: { [key: string]: any; };
}


/**
 * @export
 */
export const CaseFeedbackDtoFeedbackTypeEnum = {
    Comment: 'COMMENT',
    Analysis: 'ANALYSIS',
    Resolution: 'RESOLUTION',
    Escalation: 'ESCALATION',
    Feedback: 'FEEDBACK'
} as const;
export type CaseFeedbackDtoFeedbackTypeEnum = typeof CaseFeedbackDtoFeedbackTypeEnum[keyof typeof CaseFeedbackDtoFeedbackTypeEnum];

/**
 * @export
 */
export const CaseFeedbackDtoRatingEnum = {
    ThumbsUp: 'THUMBS_UP',
    ThumbsDown: 'THUMBS_DOWN',
    OneStar: 'ONE_STAR',
    TwoStars: 'TWO_STARS',
    ThreeStars: 'THREE_STARS',
    FourStars: 'FOUR_STARS',
    FiveStars: 'FIVE_STARS',
    Excellent: 'EXCELLENT',
    Good: 'GOOD',
    Average: 'AVERAGE',
    Poor: 'POOR',
    VeryPoor: 'VERY_POOR'
} as const;
export type CaseFeedbackDtoRatingEnum = typeof CaseFeedbackDtoRatingEnum[keyof typeof CaseFeedbackDtoRatingEnum];


/**
 * Check if a given object implements the CaseFeedbackDto interface.
 */
export function instanceOfCaseFeedbackDto(value: object): value is CaseFeedbackDto {
    return true;
}

export function CaseFeedbackDtoFromJSON(json: any): CaseFeedbackDto {
    return CaseFeedbackDtoFromJSONTyped(json, false);
}

export function CaseFeedbackDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFeedbackDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'feedbackType': json['feedbackType'] == null ? undefined : json['feedbackType'],
        'rating': json['rating'] == null ? undefined : json['rating'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function CaseFeedbackDtoToJSON(json: any): CaseFeedbackDto {
    return CaseFeedbackDtoToJSONTyped(json, false);
}

export function CaseFeedbackDtoToJSONTyped(value?: CaseFeedbackDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'feedbackType': value['feedbackType'],
        'rating': value['rating'],
        'comment': value['comment'],
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'tenantId': value['tenantId'],
        'metadata': value['metadata'],
    };
}

